export enum contentHubMicrocopy {
  CONTENT_HUB_TITLE = 'CONTENT_HUB_TITLE',
  CONTENT_HUB_RELATED_ARTICLES_TITLE = 'CONTENT_HUB_RELATED_ARTICLES_TITLE',
}
